import { trackProductEvent, type AnalyticsProperties } from '@/lib/analytics';

export const trackMealPlanAnalyseClicked = (properties: AnalyticsProperties) => {
  trackProductEvent('Meal Plan Analyse Clicked', properties);
};

export const trackMealPlanDetailedReportClicked = (properties: AnalyticsProperties) => {
  trackProductEvent('Meal Plan Detailed Report Clicked', properties);
};

export const trackMealPlanFinalizeClicked = (properties: AnalyticsProperties) => {
  trackProductEvent('Meal Plan Finalize Clicked', properties);
};

export const trackMealPlanTemplateSaveClicked = (properties: AnalyticsProperties) => {
  trackProductEvent('Meal Plan Template Save Clicked', properties);
};

export const trackMealPlanTemplateImportClicked = (properties: AnalyticsProperties) => {
  trackProductEvent('Meal Plan Template Import Clicked', properties);
};

export const trackMealPlanDayCopyClicked = (properties: AnalyticsProperties) => {
  trackProductEvent('Meal Plan Day Copy Clicked', properties);
};

export const trackMealPlanDayDeleteClicked = (properties: AnalyticsProperties) => {
  trackProductEvent('Meal Plan Day Delete Clicked', properties);
};
